import { extendTheme } from '@chakra-ui/react';
import { Any } from 'directed-graph-typed/dist/types';

export const FeedInAppTheme = extendTheme(
    {
        colors: {
            primary: "#4BAC61",
            secondary: "#00A282",
            error: "#9c3085",
            contrast: "#9c3085",
            highlight: "#065e54",
            stronghighlight: "#012e29",
            lightblack: "#1A1B1A",
            subitemblack: "#303130",
            disabled: "#969696",
            descriptionGrey: "#808080",
            darkerGrey: "#505050",
            light: "#81C490",
            frozen: "#00CCFF",
            separator: "#e4e6e8",
            catdescriptiongrey: "#686868",
            closed: "#68000",
        }, 

        styles: {
            global: (props: Any) => ({
              body: {
                fontFamily: "Roboto, sans-serifs",
                minHeight: "100%",
              },

              html: {
                minHeight: "100%",
              }
            }),
          },    
    }
);